import React from "react";

import { NavBarLateral } from "../vendedor/NavBarLateral";
import { Mensajes } from "./Mensajes";

/**
 * El centro de mensajes, pero adentro del panel y con el menu lateral al lado.
 *
 * Es el mismo chat de `/mensajes`: lo que cambia es el marco. Al entrar desde el
 * menu lateral la persona sigue dentro del panel, y quedarse sin el menu la
 * obligaba a volver por el navegador. `/mensajes` se queda como esta porque es
 * el destino del globo del header del sitio y de los deep links de las
 * notificaciones, que llegan desde afuera del panel.
 */
const MensajesPanel = () => (
  <div className="dashboard">
    <NavBarLateral />
    <div className="dashboard__content dashboard__content--chat">
      <Mensajes />
    </div>
  </div>
);

export { MensajesPanel };
